// Mock data for KRS Design and Renovation
// NOTE: All data below is MOCKED for the frontend-only version.

export const IMAGES = {
  heroInterior: "https://images.unsplash.com/photo-1768144092684-c1a5dd6c7aad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxlbGVnYW50JTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc4OTA2NjY5MXww&ixlib=rb-4.1.0&q=85",
  livingRoom1: "https://images.pexels.com/photos/8082330/pexels-photo-8082330.jpeg",
  livingRoom2: "https://images.pexels.com/photos/7174113/pexels-photo-7174113.jpeg",
  livingRoom3: "https://images.pexels.com/photos/34688219/pexels-photo-34688219.jpeg",
  kitchen1: "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxicmlnaHQlMjBtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc4MzM1ODg2NHww&ixlib=rb-4.1.0&q=85",
  kitchen2: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxicmlnaHQlMjBtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc4MzM1ODg2NHww&ixlib=rb-4.1.0&q=85",
  kitchen3: "https://images.unsplash.com/photo-1556912167-f556f1f39fdf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxicmlnaHQlMjBtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc4MzM1ODg2NHww&ixlib=rb-4.1.0&q=85",
  elegantInterior: "https://images.unsplash.com/photo-1618221312573-404f9a52798d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwaG9tZSUyMGludGVyaW9yfGVufDB8fHx8MTc4OTA2NjY5MXww&ixlib=rb-4.1.0&q=85",
  // before / dated + construction
  oldKitchen1: "https://images.unsplash.com/photo-1699615823047-700ca5e2bab4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxvbGQlMjBraXRjaGVufGVufDB8fHx8MTc4OTA2NjcyM3ww&ixlib=rb-4.1.0&q=85",
  oldKitchen2: "https://images.unsplash.com/photo-1733431769311-f33ee6f83d15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxvbGQlMjBraXRjaGVufGVufDB8fHx8MTc4OTA2NjcyM3ww&ixlib=rb-4.1.0&q=85",
  construction1: "https://images.pexels.com/photos/5691530/pexels-photo-5691530.jpeg",
  construction2: "https://images.pexels.com/photos/5691533/pexels-photo-5691533.jpeg",
  facadeSplit: "https://images.pexels.com/photos/37535123/pexels-photo-37535123.jpeg",
  kitchenReno: "https://images.pexels.com/photos/36035073/pexels-photo-36035073.jpeg",
  exteriorReno: "https://images.pexels.com/photos/28885519/pexels-photo-28885519.jpeg",
  // finished after
  bathroom1: "https://images.unsplash.com/photo-1661107259637-4e1c55462428?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBiYXRocm9vbXxlbnwwfHx8fDE3ODkwNjY3NzN8MA&ixlib=rb-4.1.0&q=85",
  bathroom2: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiYXRocm9vbXxlbnwwfHx8fDE3ODkwNjY3NzN8MA&ixlib=rb-4.1.0&q=85",
  bathroom3: "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBiYXRocm9vbXxlbnwwfHx8fDE3ODkwNjY3NzN8MA&ixlib=rb-4.1.0&q=85",
  bedroom1: "https://images.unsplash.com/photo-1744000311897-510b64f9a2e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxiZWRyb29tJTIwc3VpdGV8ZW58MHx8fHwxNzg5MDY2NzczfDA&ixlib=rb-4.1.0&q=85",
  bedroom2: "https://images.unsplash.com/photo-1612645213559-6af1d4edeaf8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxiZWRyb29tJTIwc3VpdGV8ZW58MHx8fHwxNzg5MDY2NzczfDA&ixlib=rb-4.1.0&q=85",
  dining1: "https://images.unsplash.com/photo-1635108197332-54105c0ec888",
  dining2: "https://images.unsplash.com/photo-1706820229870-f9a8c6dac193",
  dining3: "https://images.unsplash.com/photo-1635108197695-05184e426907",
  materials1: "https://images.unsplash.com/photo-1587177139620-987629766ec7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxpbnRlcmlvciUyMGRlc2lnbiUyMG1hdGVyaWFsc3xlbnwwfHx8fDE3ODkwNjY4MDJ8MA&ixlib=rb-4.1.0&q=85",
  materials2: "https://images.unsplash.com/photo-1649930536248-df58fd1f54f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxpbnRlcmlvciUyMGRlc2lnbiUyMG1hdGVyaWFsc3xlbnwwfHx8fDE3ODkwNjY4MDJ8MA&ixlib=rb-4.1.0&q=85",
  materials3: "https://images.unsplash.com/photo-1664638413509-6aa486866f9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxpbnRlcmlvciUyMGRlc2lnbiUyMG1hdGVyaWFsc3xlbnwwfHx8fDE3ODkwNjY4MDJ8MA&ixlib=rb-4.1.0&q=85",
  floorPlan1: "https://images.unsplash.com/photo-1721244654210-a505a99661e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxmbG9vciUyMHBsYW58ZW58MHx8fHwxNzg5MDY2ODAyfDA&ixlib=rb-4.1.0&q=85",
  floorPlan2: "https://images.unsplash.com/photo-1608303588026-884930af2559?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxmbG9vciUyMHBsYW58ZW58MHx8fHwxNzg5MDY2ODAyfDA&ixlib=rb-4.1.0&q=85",
  consultation: "https://images.unsplash.com/photo-1561070791-36c11767b26a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxkZXNpZ24lMjBjb25zdWx0YXRpb258ZW58MHx8fHwxNzg5MDY2ODAzfDA&ixlib=rb-4.1.0&q=85"
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Find + Renovate", path: "/find-renovate" },
  { label: "Design + Renovation", path: "/design-renovation" },
  { label: "Projects", path: "/portfolio" },
  { label: "Our Process", path: "/process" },
  { label: "About", path: "/about" }
];

export const BEFORE_AFTER = [
  {
    id: 1,
    title: "The Hillcrest Kitchen",
    location: "Maplewood",
    before: IMAGES.oldKitchen1,
    after: IMAGES.kitchen1
  },
  {
    id: 2,
    title: "Riverside Renovation",
    location: "Ashford",
    before: IMAGES.oldKitchen2,
    after: IMAGES.kitchen2
  },
  {
    id: 3,
    title: "Primary Bath Retreat",
    location: "Northgate",
    before: IMAGES.construction1,
    after: IMAGES.bathroom1
  }
];

export const HELP_PATHS = [
  {
    id: "find",
    kicker: "01 — Buyers",
    title: "I Want to Find a Home With Potential",
    body: "You don't have to find the perfect home. You need to find the right home with the right potential. We look beyond outdated kitchens, awkward layouts, and cosmetic problems to see what a property could become.",
    cta: "Help Me Find a Home",
    to: "/find-renovate",
    image: IMAGES.facadeSplit
  },
  {
    id: "renovate",
    kicker: "02 — Homeowners",
    title: "I Want to Renovate My Current Home",
    body: "Already love where you live but not the home itself? We'll help you rethink your space, create a design that works for the way you live, and manage the renovation from concept through completion.",
    cta: "Start My Renovation",
    to: "/design-renovation",
    image: IMAGES.livingRoom2
  }
];

export const DIFFERENCE_STEPS = [
  { num: "01", title: "Find", text: "Identify homes with the right location, structure, layout, value, and renovation potential." },
  { num: "02", title: "Envision", text: "Understand what the property could become before committing to the purchase or renovation." },
  { num: "03", title: "Design", text: "Develop a cohesive design based on your goals, lifestyle, taste, and investment." },
  { num: "04", title: "Transform", text: "Coordinate and execute the renovation to turn the concept into a finished home." }
];

export const RENO_PROJECTS = [
  "Kitchen renovations", "Bathroom renovations", "Primary suites",
  "Interior redesigns", "Open-concept transformations", "Flooring & finish updates",
  "Lighting plans", "Built-ins & custom details", "Whole-home renovations",
  "Layout reconfiguration", "Home additions", "Investment property renovations"
];

export const PROCESS_STEPS = [
  { num: "01", title: "Understand", text: "We begin with your goals, budget, style, lifestyle, timeline, and priorities." },
  { num: "02", title: "Explore", text: "If you're buying, we identify properties with strong potential. If you own your home, we evaluate your existing space." },
  { num: "03", title: "Envision", text: "We help define the possibilities and establish the direction for your renovation." },
  { num: "04", title: "Design", text: "We create a cohesive plan covering layouts, finishes, materials, fixtures, and colors." },
  { num: "05", title: "Renovate", text: "Our team coordinates the execution of your renovation and keeps the project moving forward." },
  { num: "06", title: "Enjoy", text: "Walk into a home that feels completely different — because it was designed around you." }
];

export const SERVICES = [
  { title: "Kitchen Renovations", text: "Create a kitchen designed around how you actually cook, gather, entertain, and live.", image: IMAGES.kitchen3 },
  { title: "Bathroom Renovations", text: "Transform dated or inefficient bathrooms into functional, comfortable, elevated spaces.", image: IMAGES.bathroom2 },
  { title: "Whole-Home Renovations", text: "Create a cohesive transformation across multiple rooms or an entire property.", image: IMAGES.livingRoom1 },
  { title: "Interior Design", text: "Bring materials, colors, finishes, furniture, lighting, and architectural elements into one intentional design.", image: IMAGES.dining1 },
  { title: "Space Planning + Layout", text: "Improve flow and functionality by rethinking walls, rooms, circulation, and how spaces connect.", image: IMAGES.floorPlan1 },
  { title: "Primary Suite Transformations", text: "Reimagine bedrooms, bathrooms, closets, and adjoining spaces into a complete retreat.", image: IMAGES.bedroom1 }
];

export const PROJECTS = [
  {
    id: "hillcrest",
    name: "The Hillcrest Residence",
    location: "Maplewood",
    type: "Whole Home",
    cover: IMAGES.livingRoom1,
    challenge: "A 1980s home with a closed-off floor plan, dated finishes, and a kitchen disconnected from the family's daily life.",
    vision: "An open, light-filled main level built for gathering, cooking, and everyday living.",
    transformation: "Removed load-bearing walls to open the layout, rebuilt the kitchen with custom cabinetry, and refreshed every finish throughout.",
    gallery: [IMAGES.kitchen1, IMAGES.livingRoom1, IMAGES.dining2],
    before: IMAGES.oldKitchen1,
    after: IMAGES.kitchen1
  },
  {
    id: "riverside",
    name: "Riverside Fixer-Upper",
    location: "Ashford",
    type: "Fixer-Upper Transformation",
    cover: IMAGES.kitchen2,
    challenge: "A structurally sound but visually tired property most buyers walked away from.",
    vision: "A warm, modern family home that honored the original character.",
    transformation: "Reconfigured the layout, updated all systems, and introduced a bright, timeless material palette.",
    gallery: [IMAGES.kitchen2, IMAGES.livingRoom2, IMAGES.bedroom2],
    before: IMAGES.oldKitchen2,
    after: IMAGES.kitchen2
  },
  {
    id: "northgate",
    name: "Northgate Primary Suite",
    location: "Northgate",
    type: "Primary Suite",
    cover: IMAGES.bathroom1,
    challenge: "A cramped primary bath and a bedroom that felt like an afterthought.",
    vision: "A spa-like retreat that felt calm, private, and elevated.",
    transformation: "Expanded the footprint, added a walk-in shower and soaking tub, and layered natural stone and warm brass.",
    gallery: [IMAGES.bathroom1, IMAGES.bathroom3, IMAGES.bedroom1],
    before: IMAGES.construction1,
    after: IMAGES.bathroom1
  },
  {
    id: "brookline",
    name: "Brookline Kitchen",
    location: "Brookline",
    type: "Kitchen",
    cover: IMAGES.kitchen3,
    challenge: "A narrow galley kitchen with limited storage and poor natural light.",
    vision: "An open entertaining kitchen with room to cook and connect.",
    transformation: "Relocated appliances, added an island, and introduced a mix of warm woods and honed stone.",
    gallery: [IMAGES.kitchen3, IMAGES.dining1, IMAGES.materials1],
    before: IMAGES.kitchenReno,
    after: IMAGES.kitchen3
  },
  {
    id: "westfield",
    name: "Westfield Bath",
    location: "Westfield",
    type: "Bathroom",
    cover: IMAGES.bathroom2,
    challenge: "A dated hall bath that no longer served a growing family.",
    vision: "A bright, durable, and beautiful shared bathroom.",
    transformation: "Reworked the plumbing, added double vanities, and finished with timeless tile.",
    gallery: [IMAGES.bathroom2, IMAGES.bathroom3, IMAGES.materials2],
    before: IMAGES.construction2,
    after: IMAGES.bathroom2
  },
  {
    id: "lakeview",
    name: "Lakeview Great Room",
    location: "Lakeview",
    type: "Whole Home",
    cover: IMAGES.livingRoom3,
    challenge: "Compartmentalized rooms that hid the property's best views.",
    vision: "A connected, view-forward living space for entertaining.",
    transformation: "Opened the great room, added floor-to-ceiling windows, and grounded the space in warm neutrals.",
    gallery: [IMAGES.livingRoom3, IMAGES.dining3, IMAGES.elegantInterior],
    before: IMAGES.exteriorReno,
    after: IMAGES.livingRoom3
  }
];

export const PROPERTY_FACTORS = [
  "Location", "Neighborhood", "Purchase price", "Renovation potential",
  "Existing layout", "Structural considerations", "Expansion possibilities",
  "Natural light", "Kitchen opportunities", "Primary suite potential",
  "Outdoor spaces", "Resale considerations", "Your overall investment"
];

export const DESIGN_SCOPE = [
  "Space planning", "Floor plan modifications", "Kitchen design", "Bathroom design",
  "Interior finishes", "Paint & color direction", "Flooring", "Lighting",
  "Cabinetry", "Countertops", "Fixtures", "Hardware", "Built-ins",
  "Furniture & styling", "Whole-home design"
];

export const IDEAL_CLIENT = [
  "You want to buy in a particular neighborhood but renovated homes are limited.",
  "You love the location of a property but not the interior.",
  "You're open to a fixer-upper but aren't sure how much work it needs.",
  "You struggle to visualize what dated homes could become.",
  "You want professional input when considering properties.",
  "You'd rather customize a home than pay a premium for someone else's renovation.",
  "You want one team involved from property search through transformation."
];

export const BUYER_PROCESS = [
  { num: "01", title: "Discovery", text: "Tell us what you're looking for, where you want to live, your budget, your style, and your renovation goals." },
  { num: "02", title: "Home Search", text: "We help identify properties that match your criteria and show promising renovation potential." },
  { num: "03", title: "Property Evaluation", text: "We help you look beyond the existing finishes and evaluate what may be possible." },
  { num: "04", title: "Purchase", text: "Once you find the right home, we guide you through the real estate process." },
  { num: "05", title: "Design", text: "We develop the vision and design for the renovation." },
  { num: "06", title: "Planning", text: "Materials, selections, layouts, scope, budgets, and schedules are coordinated." },
  { num: "07", title: "Renovation", text: "The transformation begins." },
  { num: "08", title: "Completion", text: "Your fixer-upper becomes your home." }
];

export const HOMEOWNER_PROCESS = [
  { num: "01", title: "Consultation", text: "We discuss your home, goals, pain points, style, and priorities." },
  { num: "02", title: "Property Review", text: "We evaluate the existing space and discuss opportunities." },
  { num: "03", title: "Concept", text: "We define the overall renovation and design direction." },
  { num: "04", title: "Design Development", text: "Layouts, finishes, fixtures, materials, and other selections are finalized." },
  { num: "05", title: "Project Planning", text: "Scope, budget, timeline, and execution are coordinated." },
  { num: "06", title: "Construction", text: "The design comes to life." },
  { num: "07", title: "Final Details", text: "We complete the project and bring everything together." },
  { num: "08", title: "Enjoy Your Home", text: "A familiar address with an entirely new experience." }
];

export const FAQS = [
  { q: "Can you help us find a fixer-upper?", a: "Yes. We can help identify homes that meet your real estate criteria while also evaluating them through the lens of renovation potential." },
  { q: "Should we contact you before we start looking at houses?", a: "Ideally, yes. Having renovation and design considerations in mind during the search can help you evaluate properties differently and potentially avoid purchasing a home that doesn't align with your goals." },
  { q: "Can you help us understand what a house could look like before we buy it?", a: "That's one of the biggest advantages of our approach. We help clients look past existing finishes and layouts to understand the property's potential." },
  { q: "Do we have to use you as our realtor to use your design services?", a: "Not necessarily. We're happy to discuss the arrangement that works best for your situation during your first conversation." },
  { q: "Do you work with homeowners who aren't moving?", a: "Absolutely. A large part of our work is helping current homeowners redesign and renovate the home they already own." },
  { q: "What types of renovations do you handle?", a: "Projects can range from kitchens and bathrooms to significant interior renovations and whole-home transformations." },
  { q: "Do you help select materials and finishes?", a: "Yes. Design can include flooring, cabinetry, countertops, lighting, fixtures, paint colors, hardware, and other interior elements depending on the scope of the project." },
  { q: "How much does a renovation cost?", a: "Every project is different. Cost depends on the size of the home, scope of work, materials, structural changes, location, and level of finishes. We discuss budget early so the design aligns with the investment you're comfortable making." }
];

export const PROJECT_TYPES = [
  "Find + Renovate a Home", "Whole-Home Renovation", "Kitchen", "Bathroom",
  "Primary Suite", "Interior Design", "Addition", "Multiple Rooms",
  "Investment Property", "Other"
];

export const BUDGET_RANGES = [
  "Under $50,000", "$50,000 – $100,000", "$100,000 – $250,000",
  "$250,000 – $500,000", "$500,000+"
];
